import React from "react";
import { X, Edit, Trash } from "lucide-react";

const MobileTransactionsInfo = ({ transaction, onClose, onEdit, onDelete }) => {
  if (!transaction) return null;

  const handleEditClick = () => {
    onEdit(transaction);
    onClose(); 
  };

  const handleDeleteClick = () => {
    onDelete(transaction.id);
    onClose(); 
  };

  const typeStyles = {
    income: {
      badge: "bg-green-100 text-green-800",
      amount: "text-green-600",
      symbol: "+",
    },
    expense: {
      badge: "bg-red-100 text-red-800",
      amount: "text-red-600",
      symbol: "-",
    },
  };

  const currentStyle = typeStyles[transaction.type] || typeStyles.expense;

  return (
    <>
      {/* Overlay */}
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
        onClick={onClose}
        aria-hidden="true"
      ></div>

      {/* Bottom Sheet Modal */}
      <div className="fixed bottom-0 left-0 right-0 bg-white rounded-t-2xl shadow-2xl p-6 z-50 lg:hidden animate-slide-up">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-bold text-gray-800">Transaction Details</h3>
          <button onClick={onClose} className="p-2 text-gray-400 hover:text-gray-600">
            <X size={24} />
          </button>
        </div>

        <div className="border-t border-gray-200 pt-4">
          <div className="text-center mb-6">
            <p className="text-sm text-gray-500">{transaction.description || "No Description"}</p>
            <p className={`text-4xl font-bold font-mono my-2 ${currentStyle.amount}`}>
              {currentStyle.symbol}€{transaction.amount.toFixed(2)}
            </p>
          </div>

          <div className="space-y-3 text-sm">
            <div className="flex justify-between items-center bg-gray-50 p-3 rounded-lg">
              <span className="font-semibold text-gray-600">Type</span>
              <span className={`px-3 py-1 text-xs font-semibold rounded-full ${currentStyle.badge}`}>
                {transaction.type.charAt(0).toUpperCase() + transaction.type.slice(1)}
              </span>
            </div>
            {/* --- ADDED CATEGORY FIELD --- */}
            <div className="flex justify-between items-center bg-gray-50 p-3 rounded-lg">
              <span className="font-semibold text-gray-600">Category</span>
              <span className="text-gray-800 font-medium capitalize">
                {transaction.category || "Uncategorized"}
              </span>
            </div>
            {/* --- END OF ADDED FIELD --- */}
            <div className="flex justify-between items-center bg-gray-50 p-3 rounded-lg">
              <span className="font-semibold text-gray-600">Date</span>
              <span className="text-gray-800">{transaction.date}</span>
            </div>
            <div className="flex justify-between items-center bg-gray-50 p-3 rounded-lg">
              <span className="font-semibold text-gray-600">Time</span>
              <span className="text-gray-800">{transaction.time}</span>
            </div>
            <div className="flex justify-between items-center bg-gray-50 p-3 rounded-lg">
              <span className="font-semibold text-gray-600">Transaction ID</span>
              <span className="text-gray-800 font-mono truncate max-w-[150px]">{transaction.id}</span>
            </div>
          </div>

          <div className="mt-8 flex items-center gap-4">
            <button
              onClick={handleEditClick}
              className="flex-1 flex items-center justify-center gap-2 py-3 px-4 bg-gray-100 text-[#2ecfe3] font-semibold rounded-lg hover:bg-gray-200 transition"
            >
              <Edit size={18} />
              <span>Edit</span>
            </button>
            <button
              onClick={handleDeleteClick}
              className="flex-1 flex items-center justify-center gap-2 py-3 px-4 bg-red-50 text-red-600 font-semibold rounded-lg hover:bg-red-100 transition"
            >
              <Trash size={18} />
              <span>Delete</span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileTransactionsInfo;